<template>
    <div class="bg-white cancelBox">
        <div class="topFont bg-white">
            <i class="el-icon-arrow-left" style="margin-left: 8px; color: #000000" @click="$router.go(-1)"></i>
            <span style="font-size: 16px;margin-left: 4px">Cancel Order</span>
        </div>
        <div class="solidBorder"></div>
        <div class="reasonSelect f-b f--c bg-white" @click.self="visible = true">
            <span class="requiredLabel" :style="{color: text === 'Cancel Reason' ? '#B6B6B6' : '#333333'}" @click.self="visible = true">{{text}}</span>
            <i class="iconfont icon-jiantou-xuanze" />
            <m-picker :value="dialogParams.operationType" :visible.sync="visible" show-toolbar :columns="cancelReasonSelectList" :customField="{ label: 'name', value: 'code' }" @confirm="confirm" />
        </div>
        <div class="remarkBox">
            <el-input
                type="textarea"
                placeholder="Verification"
                v-model="dialogParams.remark"
                resize="none"
                :autosize="true" />
        </div>
        <div class="bottomBtn f-c-c">
            <el-button type="primary" style="width: 94%;height: 44px;border-radius: 8px;" @click="dialogConfirmCancelRefund">{{ $t('Order.Details.Components.CancelMT.Submit') }}</el-button>
        </div>
    </div>
</template>

<script>
// import Picker from '@/components/mobile/Picker.vue'
// import BigSelect from '@/components/mobile/BigSelect.vue'
import Picker from '@/components/mobile/Picker.vue'
import API from '@/api'
export default {
  components: {
    'm-picker': Picker
    // BigSelect
  },
  data() {
    return {
      dialogParams: {
        remark: undefined,
        kkOrderId: undefined,
        operationType: undefined
      },
      reasonCode: undefined,
      visible: false,
      customField: { label: 'name', value: 'code' },
      placeholder: 'Cancel Reason'
    }
  },
  computed: {
    cancelReasonSelectList() {
      let arr = this.$store.state.common.cancelReasonSelectList
      if (!arr.length) {
        this.$store.dispatch('common/getCancelReasonSelectList')
      }
      return arr
    },
    text() {
      const column = this.cancelReasonSelectList.find(item => item[this.customField.value] === this.dialogParams.operationType)
      return column ? column[this.customField.label] : this.placeholder
    }
  },
  created() {
    this.dialogParams.kkOrderId = this.$route.query.kkOrderId
    // console.log(this.cancelReasonSelectList)
  },
  methods: {
    confirm(value) {
      console.log(value)
      this.dialogParams.operationType = value
    },
    dialogConfirmCancelRefund() {
      const params = new FormData()
      if (this.dialogParams.operationType === undefined || this.dialogParams.operationType === null) {
        this.$message.error(this.CancellationReasonIsRequiredText)
        return
      }
      Object.keys(this.dialogParams).forEach((key) => {
        if (this.dialogParams[key] !== undefined) params.append(key, this.dialogParams[key])
      })
      API.orderCancel(params)
        .then((res) => {
          if (res.code === 10000) {
            this.$message.success(res.message)
            this.$router.go(-1)
          } else {
            let message = res.message
            this.$message.error(message)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.cancelBox{
    height: calc(100vh - 43px);
}
.topFont{
    height: 40px;
    color: #7B7B7B;
    line-height: 40px;
}
.reasonSelect{
    height: 60px;
    padding: 0 18px;
}
.requiredLabel::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
}
.solidBorder{
    height: 10px;
    width: 100%;
    background-color: #f4f5f5;
}
.remarkBox{
    /deep/.el-textarea{
        height: calc(100vh - 153px);
    }
    /deep/textarea{
        border: none !important;
        height: calc(100vh - 153px) !important;

    }
}
.bottomBtn{
    height: 58px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>
